import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Card, CardContent } from "@/components/ui/card";
import { BookOpen, Zap, Shield } from "lucide-react";

const About = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold text-center mb-6 animate-fade-in">
            About FaydaLibrary
          </h1>
          <p className="text-xl text-center text-muted-foreground mb-12 animate-slide-up">
            Your modern digital library powered by headless WordPress
          </p>

          <div className="grid md:grid-cols-3 gap-6 mb-12">
            <Card className="gradient-card text-center animate-scale-in">
              <CardContent className="p-6">
                <BookOpen className="h-12 w-12 text-primary mx-auto mb-4" />
                <h3 className="font-semibold mb-2">Vast Collection</h3>
                <p className="text-sm text-muted-foreground">
                  Access thousands of eBooks across all genres and categories
                </p>
              </CardContent>
            </Card>

            <Card className="gradient-card text-center animate-scale-in" style={{ animationDelay: "0.1s" }}>
              <CardContent className="p-6">
                <Zap className="h-12 w-12 text-primary mx-auto mb-4" />
                <h3 className="font-semibold mb-2">Lightning Fast</h3>
                <p className="text-sm text-muted-foreground">
                  Modern React frontend for optimal performance
                </p>
              </CardContent>
            </Card>

            <Card className="gradient-card text-center animate-scale-in" style={{ animationDelay: "0.2s" }}>
              <CardContent className="p-6">
                <Shield className="h-12 w-12 text-primary mx-auto mb-4" />
                <h3 className="font-semibold mb-2">WordPress Backend</h3>
                <p className="text-sm text-muted-foreground">
                  Easy content management with WordPress you know and love
                </p>
              </CardContent>
            </Card>
          </div>

          <Card className="gradient-card">
            <CardContent className="p-8">
              <h2 className="text-2xl font-bold mb-4">How It Works</h2>
              <div className="space-y-4 text-muted-foreground">
                <p>
                  FaydaLibrary uses a modern <strong>headless WordPress</strong> architecture. This means:
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Content is managed through your familiar WordPress dashboard</li>
                  <li>Books, authors, and metadata are stored in WordPress custom post types</li>
                  <li>The frontend (this beautiful interface) fetches data via WordPress REST API</li>
                  <li>Users get a fast, modern reading experience</li>
                  <li>You get easy content management</li>
                </ul>
                <p className="pt-4">
                  To connect this frontend to your WordPress backend, simply configure the API endpoint 
                  in the application settings and ensure your WordPress installation has the proper REST API 
                  endpoints enabled for the 'ebook' custom post type.
                </p>
              </div>
            </CardContent>
          </Card>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default About;
